import React, {memo, useEffect, useState} from "react";
import {Checkbox} from "@material-ui/core";
import {Col, Form, Row} from "react-bootstrap";

function Zeit({
                  disableStatus,
                  estimatableTime,
                  originState,
                  meister,
                  monteur,
                  geselle,
                  lehrling,
                  helfer,
                  stundenReportData,
                  setStundenReportData,
                  totalDuration,
                  setIsChange,

              }) {

    const [newEstimatableTime, setNewEstimatableTime] = useState(estimatableTime);
    const [gesamtStunden, setGesamtStunden] = useState(totalDuration)

    useEffect(() => {
        setNewEstimatableTime(estimatableTime);
        setGesamtStunden(parseFloat(helfer) + parseFloat(meister) + parseFloat(monteur) + parseFloat(geselle) + parseFloat(lehrling))
        //+ parseFloat(helfer))


    }, [originState, totalDuration, estimatableTime])

    const handleChange = (event) => {
        const newValue = event.target.checked ? "no" : "yes";
        setStundenReportData({
            ...stundenReportData, estimatableTime: newValue
        })
        setNewEstimatableTime(newValue);
    };


    return (<>
        <Row>
            <Col sm={4}>
                <label className="handwai-text-label-main">{"Zeit"}</label>
            </Col>
        </Row>
        <br/>

        <Row>
            <Col sm={1}>
                <div

                >
                    {originState === true || disableStatus ? <Checkbox
                        style={{width: "30%", backgroundColor: "White"}}
                        color='White'
                        disabled
                        checked={estimatableTime !== "yes"}/> : <Checkbox
                        style={{width: "30%", backgroundColor: "White"}}
                        color='White'
                        disabled={disableStatus}
                        checked={newEstimatableTime !== "yes"}
                        onChange={handleChange}
                    />}
                </div>
            </Col>
            <Col sm={1} style={{marginLeft: -110, alignLeft: "left"}}>
                <label className="handwai-text-label-normal add-bottom-0-margin">
                    {"Nicht Schätzbar"}
                </label>
            </Col>
        </Row>

        <br/>
        <br/>

        {(newEstimatableTime !== "no" || newEstimatableTime === "yes") && <>
            <Row>
                <Col sm={1} style={{marginRight: -90}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Meister:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={originState || disableStatus}
                           key={meister}
                           defaultValue={meister}
                           onChange={(e) => {
                               setIsChange(false)
                               setGesamtStunden(parseFloat(helfer) + parseFloat(e.target.value) + parseFloat(monteur) + parseFloat(geselle) + parseFloat(lehrling))

                               let newState = Object.assign({}, stundenReportData);
                               newState.estimation.roles.meister = e.target.value;
                               setStundenReportData(newState);
                           }}
                    />
                </Col>

                <Col sm={2} style={{marginRight: -170}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Bauleitender Monteur:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={originState || disableStatus}
                           key={monteur}
                           defaultValue={monteur}
                           onChange={(e) => {
                               setIsChange(false)
                               setGesamtStunden(parseFloat(helfer) + parseFloat(meister) + parseFloat(e.target.value) + parseFloat(geselle) + parseFloat(lehrling))

                               let newState = Object.assign({}, stundenReportData);
                               newState.estimation.roles.bauleitender_monteur = e.target.value;
                               setStundenReportData(newState);
                           }}
                    />
                </Col>

                <Col sm={1} style={{marginRight: -90}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Geselle:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={originState || disableStatus}
                           key={geselle}
                           defaultValue={geselle}
                           onChange={(e) => {
                               setIsChange(false)
                               setGesamtStunden(parseFloat(helfer) + parseFloat(meister) + parseFloat(monteur) + parseFloat(e.target.value) + parseFloat(lehrling))

                               let newState = Object.assign({}, stundenReportData);
                               newState.estimation.roles.geselle = e.target.value;
                               setStundenReportData(newState);
                           }}
                    />
                </Col>

                <Col sm={1} style={{marginRight: -90}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Lehrling:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={originState || disableStatus}
                           key={lehrling}
                           defaultValue={lehrling}
                           onChange={(e) => {
                               setIsChange(false)
                               setGesamtStunden(parseFloat(helfer) + parseFloat(meister) + parseFloat(monteur) + parseFloat(geselle) + parseFloat(e.target.value))

                               let newState = Object.assign({}, stundenReportData);
                               newState.estimation.roles.lehrling = e.target.value;
                               setStundenReportData(newState);
                           }}
                    />
                </Col>


                <Col sm={1} style={{marginRight: -100}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Helfer:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={originState || disableStatus}
                           key={helfer}
                           defaultValue={helfer}
                           onChange={(e) => {
                               setIsChange(false)
                               setGesamtStunden(parseFloat(e.target.value) + parseFloat(meister) + parseFloat(monteur) + parseFloat(geselle) + parseFloat(lehrling))

                               let newState = Object.assign({}, stundenReportData);
                               newState.estimation.roles.helfer = e.target.value;
                               setStundenReportData(newState);
                           }}
                    />
                </Col>

                <Col sm={1} style={{marginRight: -10}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Gesamtstunden:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled
                           key={gesamtStunden}
                           defaultValue={gesamtStunden}
                    />
                </Col>

                <br/>
            </Row>

        </>


        }
        <br/><br/><br/>


    </>)

}

export default memo(Zeit)